export default {"src":"/_next/static/media/phone-outline.5326cfc7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};